export const chatWidgetKeywords = {
  default: ['Technical support',
    'Email',
    'Tech support',
    'Chat',
    'Contact',
    'Claim',
    'Support',
    'Repair',
    'Phone number',
    'Customer care number',
    'Customer service',
    'Customer support',
    'Contact details'
  ],
  cs: ['Technická podpora',
    'E‑mail',
    'Chat',
    'Kontakt',
    'Reklamace',
    'Podpora',
    'Oprava',
    'Telefonní číslo',
    'Zákaznické číslo',
    'Zákaznický servis',
    'Zákaznická podpora',
    'Kontaktní údaje'
  ],
  el: ['Τεχνική υποστήριξη',
    'Email',
    'η‑mail',
    'Συνομιλία',
    'Επικοινωνία',
    'Επαφή',
    'Απαίτηση',
    'Καταγγελία',
    'Υποστήριξη',
    'Επισκευή',
    'Αριθμός τηλεφώνου',
    'Αριθμός εξυπηρέτησης πελατών',
    'Εξυπηρέτηση πελατών',
    'Υποστήριξη πελατών',
    'Στοιχεία επικοινωνίας'
  ],
  et: [
    'Tehniline tugi',
    'E‑post',
    'Jututuba',
    'Kontakt',
    'Nõue',
    'Tugi',
    'Remont',
    'Telefoninumber',
    'Klienditoe number',
    'Klienditeenindus',
    'Klienditugi',
    'Kontaktandmed'
  ],
  fi: ['Tekninen tuki',
    'Sähköposti',
    'Keskustelu',
    'Yhteystieto',
    'Reklamaatio',
    'Vaatimus',
    'Tuki',
    'Korjaus',
    'Puhelinnumero',
    'Asiakaspalvelunumero',
    'Asiakaspalvelu',
    'Asiakastuki',
    'Yhteystiedot'
  ],
  fr: ['Support technique',
    'Email',
    'Chat',
    'Contact',
    'Réclamation',
    'Assistance',
    'Réparation',
    'Numéro de téléphone',
    'Numéro du service client',
    'Service client',
    'Support client',
    'Coordonnées'
  ],
  he: ['תמיכה טכנית',
    'דוא״ל',
    'צ׳אט',
    'יצירת קשר',
    'תביעה',
    'פנייה',
    'תמיכה',
    'תיקון',
    'מספר טלפון',
    'מספר שירות לקוחות',
    'שירות לקוחות',
    'תמיכה בלקוחות',
    'פרטי קשר'
  ],
  hr: ['Tehnička podrška',
    'E‑mail',
    'Chat',
    'Kontakt',
    'Prigovor',
    'Zahtjev',
    'Podrška',
    'Popravak',
    'Telefonski broj',
    'Broj korisničke podrške',
    'Korisnička služba',
    'Korisnička podrška',
    'Kontakt podaci'
  ],
  hu: ['Műszaki támogatás',
    'E‑mail',
    'Chat',
    'Kapcsolat',
    'Igény',
    'Panasz',
    'Támogatás',
    'Javítás',
    'Telefonszám',
    'Ügyfélszolgálati szám',
    'Ügyfélszolgálat',
    'Ügyféltámogatás',
    'Elérhetőségek'
  ],
  ja: ['技術サポート',
    'メール',
    'チャット',
    '連絡先',
    'クレーム',
    'サポート',
    '修理',
    '電話番号',
    'カスタマーケア番号',
    'カスタマーサービス',
    'カスタマーサポート',
    '連絡先情報'
  ],
  ko: ['기술 지원',
    '이메일',
    '채팅',
    '연락처',
    '청구',
    '클레임',
    '지원',
    '수리',
    '전화번호',
    '고객 지원 번호',
    '고객 서비스',
    '고객 지원',
    '연락처 정보'
  ],
  lt: ['Techninė pagalba',
    'El. paštas',
    'Pokalbis',
    'Kontaktas',
    'Pretenzija',
    'Pagalba',
    'Remontas',
    'Telefono numeris',
    'Klientų priežiūros numeris',
    'Klientų aptarnavimas',
    'Klientų palaikymas',
    'Kontaktinė informacija'
  ],
  lv: ['Tehniskais atbalsts',
    'E‑pasts',
    'Tērzēšana',
    'Kontakts',
    'Prasība',
    'Atbalsts',
    'Remonts',
    'Tālruņa numurs',
    'Klientu atbalsta numurs',
    'Klientu apkalpošana',
    'Klientu atbalsts',
    'Kontaktinformācija'
  ],
  ro: ['Suport tehnic',
    'E‑mail',
    'Chat',
    'Contact',
    'Reclamație',
    'Suport',
    'Reparație',
    'Număr de telefon',
    'Număr pentru relații cu clienții',
    'Serviciu clienți',
    'Asistență clienți',
    'Date de contact'
  ],
  ru: ['Техническая поддержка',
    'Электронная почта',
    'Чат',
    'Контакт',
    'Претензия',
    'Поддержка',
    'Ремонт',
    'Номер телефона',
    'Номер службы поддержки',
    'Обслуживание клиентов',
    'Поддержка клиентов',
    'Контактные данные'
  ],
  sk: ['Technická podpora',
    'E‑mail',
    'Chat',
    'Kontakt',
    'Reklamácia',
    'Podpora',
    'Oprava',
    'Telefónne číslo',
    'Číslo zákazníckej starostlivosti',
    'Zákaznícky servis',
    'Zákaznícka podpora',
    'Kontaktné údaje'
  ],
  sl: ['Tehnična podpora',
    'E‑pošta',
    'Klepet',
    'Stik',
    'Zahteva',
    'Pritožba',
    'Podpora',
    'Popravilo',
    'Telefonska številka',
    'Številka za stike s strankami',
    'Služba za pomoč strankam',
    'Podpora strankam',
    'Kontaktni podatki'
  ],
  sr: ['Техничка подршка',
    'Имејл',
    'Чет',
    'Контакт',
    'Рекламација',
    'Подршка',
    'Поправка',
    'Телефонски број',
    'Број за корисничку подршку',
    'Корисничка служба',
    'Корисничка подршка',
    'Контакт подаци'
  ],
  tr: ['Teknik destek',
    'E‑posta',
    'Sohbet',
    'İletişim',
    'Talep',
    'Şikayet',
    'Destek',
    'Onarım',
    'Telefon numarası',
    'Müşteri hizmetleri numarası',
    'Müşteri hizmetleri',
    'Müşteri desteği',
    'İletişim bilgileri'
  ],
  uk: ['Технічна підтримка',
    'Електронна пошта',
    'Чат',
    'Контакт',
    'Претензія',
    'Підтримка',
    'Ремонт',
    'Номер телефону',
    'Номер служби підтримки клієнтів',
    'Обслуговування клієнтів',
    'Підтримка клієнтів',
    'Контактні дані'
  ],
  vi: ['Hỗ trợ kỹ thuật',
    'Thư điện tử',
    'Trò chuyện',
    'Liên hệ',
    'Khiếu nại',
    'Hỗ trợ',
    'Sửa chữa',
    'Số điện thoại',
    'Số chăm sóc khách hàng',
    'Dịch vụ khách hàng',
    'Hỗ trợ khách hàng',
    'Thông tin liên hệ'
  ],
  zh:{
    cn: ['技术支持',
      '电子邮件',
      '聊天',
      '联系',
      '索赔',
      '投诉',
      '支持',
      '维修',
      '电话号码',
      '客服电话',
      '客服服务',
      '客户支持',
      '联系方式'
    ],
    tw: ['技术支援',
      '电子邮件',
      '聊天',
      '联系',
      '索赔',
      '投诉',
      '支持',
      '维修',
      '电话号码',
      '客服电话',
      '客服服务',
      '客户支持',
      '联系方式'
    ]
  },
  bg: ['Техническа поддръжка',
    'Имейл',
    'Чат',
    'Контакт',
    'Претенция',
    'Поддръжка',
    'Ремонт',
    'Телефонен номер',
    'Номер за обслужване на клиенти',
    'Обслужване на клиенти',
    'Клиентска поддръжка',
    'Данни за контакт'
  ],
  ar: ['الدعم الفني',
    'البريد الإلكتروني',
    'الدردشة',
    'الاتصال',
    'مطالبة',
    'الدعم',
    'الإصلاح',
    'رقم الهاتف',
    'رقم خدمة العملاء',
    'خدمة العملاء',
    'دعم العملاء',
    'تفاصيل الاتصال'
  ],
};